// src/components/Header.js
import React, { useEffect, useState } from 'react';
import './header.css';
import img1 from '../Assets/Logo.png';

const Header = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  const [isHeaderFixed, setIsHeaderFixed] = useState(false);

  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
      setMenuOpen(false); // Close the menu when a menu item is clicked
    }
  };

  useEffect(() => {
    scrollToSection('home');

    // Add event listener for scrolling
    window.addEventListener('scroll', handleScroll);

    // Cleanup event listener on component unmount
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  const handleScroll = () => {
    // Check scroll position to determine whether to fix the header
    const scrollPosition = window.scrollY;
    setIsHeaderFixed(scrollPosition > 50); // You can adjust the threshold as needed
  };

  const toggleMenu = () => {
    setMenuOpen(!menuOpen);
  };

  return (
    <header className={`header ${isHeaderFixed ? 'fixed' : ''}`}>
      <div className="header-container">
        <div className="company-menu-container">
          <img className="company-name" src={img1} onClick={() => scrollToSection('hero')} alt="ATDigital" />
          <div className="menu-icon" onClick={toggleMenu}>
            <span></span>
            <span></span>
            <span></span>
          </div>
        </div>
        <nav className={menuOpen ? 'show' : ''}>
          <ul>
            <li onClick={() => scrollToSection('services')}>Services</li>
            <li onClick={() => scrollToSection('aboutus')}>About Us</li>
            <li onClick={() => scrollToSection('contactus')}>Contact Us</li>
            <li onClick={() => scrollToSection('careers')}>Careers</li>
          </ul>
        </nav>
      </div>
    </header>
  );
};

export default Header;